import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import styles from './Arrow.css';

/**
 * renders white arrow facing down
 * @param {object} props - component props
 * @param {string} props.facing - arrow direction
 * @param {string} props.theme - styling from parent
 * @param {string} props.color - arrow color
 * @returns {Node} rendered arrow
 */
const Arrow = ({ facing, color, theme }) => {
  const appearance = `${color}Arrow${capitalize(facing)}`;

  return <div className={classnames(theme, styles[appearance])} />;
};

Arrow.propTypes = {
  facing: propTypes.string.isRequired,
  color: propTypes.string,
  theme: propTypes.string
};

Arrow.defaultProps = {
  color: 'default',
  theme: ''
};

export default Arrow;
